
























































import { Component, Prop, Vue } from 'vue-property-decorator';
import Logo from './logo.vue';
import { QBtnDropdown, QBtn, QItem, QItemSection, QItemLabel } from 'quasar';
import { TranslatedComponent } from '../translatedComponent';

@Component({ components: { Logo, QBtnDropdown, QBtn, QItem, QItemSection, QItemLabel } })
export default class Menu extends TranslatedComponent {
    get languages() {
        return Object.keys(this.$store.state.products);
    }

    private setLanguage(lang: string) {
        this.$store.commit('setLanguage', lang);
    }
}
